import { FORM_ELEMENTS_TYPES_TO_CLASSES } from "../utils/form-builder.types";
export const hasPhrase = ({ element, phrase, exceptionalSlug, isComplexSlug }) => {
  const extractedPhrase = getSlugFromId(element == null ? void 0 : element.id, isComplexSlug);
  if (extractedPhrase == null ? void 0 : extractedPhrase.includes(exceptionalSlug)) {
    const elementIndex = extractedPhrase.split("_").pop();
    const extractedNestedPhrase = `${exceptionalSlug}_${elementIndex}`;
    return extractedPhrase === extractedNestedPhrase;
  } else {
    return phrase === extractedPhrase;
  }
};
export const getCleanFormElementId = (formElementId) => {
  const regex = /^([a-zA-Z0-9_]+)(?:\[[a-zA-Z0-9_]+\])?(?:\[\])?$/;
  const match = formElementId.match(regex);
  const cleanSlugIndex = 1;
  return (match == null ? void 0 : match[cleanSlugIndex]) || "";
};
export const getSlugFromId = (id, isComplexSlug) => {
  const parts = id.split("_");
  parts.pop();
  if (isComplexSlug) parts.pop();
  return parts.join("_");
};
export const hasNestedObject = (obj) => {
  if (typeof obj !== "object") return;
  return Object.values(obj).some((value) => typeof value === "object" && value !== null && !Array.isArray(value));
};
export const checkValuesEquality = (valueX, valueY) => {
  return valueX && valueY && typeof valueX === "object" && typeof valueY === "object" ? Object.keys(valueX).length === Object.keys(valueY).length && Object.keys(valueX).every((key) => checkValuesEquality(valueX[key], valueY[key])) : valueX === valueY;
};
export const elementClassToType = (elementClass) => {
  if (!elementClass) return;
  const elementTypeIndex = 0;
  const element = Object.entries(FORM_ELEMENTS_TYPES_TO_CLASSES).find(([elementType, cleanElementClass]) => {
    const splitInputType = cleanElementClass.split(" ");
    const splitClass = elementClass.split(" ");
    return splitClass[1] === splitInputType[1] ? elementType : null;
  });
  return (element == null ? void 0 : element[elementTypeIndex]) || null;
};
export const getPeopleMappingFieldName = (name) => name == null ? void 0 : name.replace(/\[\]$/, "");
